var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#fd875e",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.66 17.386l2.386-7.112 2.43 7.112zm10.112 4.497l-1.973-5.309h1.178a.849.849 0 00.85-.836c0-.21-.086-.413-.237-.561s-.358-.233-.573-.233h-1.84l-.295-.826h2.095a.839.839 0 00.846-.807c.001-.222-.088-.434-.248-.59s-.376-.244-.602-.243h-2.72L18.78 8.51a3.576 3.576 0 00-1.057-1.461 2.499 2.499 0 00-1.663-.548 2.57 2.57 0 00-1.671.548 3.609 3.609 0 00-1.06 1.46l-1.543 4.004H9.082a.81.81 0 00-.817.797c0 .458.379.829.847.829h2.053l-.316.804h-1.84a.809.809 0 00-.818.8c0 .454.374.821.836.823h1.181l-2.006 5.316c-.123.3-.191.618-.202.941.02.453.222.88.56 1.19a2.04 2.04 0 001.34.483 1.8 1.8 0 001.84-1.305l.776-2.269h7.144l.777 2.323a1.813 1.813 0 001.84 1.24c.31.007.615-.07.884-.22.233-.17.44-.37.614-.598a1.6 1.6 0 00.225-.844 5.446 5.446 0 00-.228-.927z",
    fill: "#fefefe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppc);
export default __webpack_public_path__ + "static/media/appc.b4be54ecb68dd6ab30f0c51212787abd.svg";
export { ForwardRef as ReactComponent };